import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  inject,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser, Location } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';

import { LanguageServiceService } from '../../services/language-service.service';
import { LoginService } from '../../components/Authentication/auth/login.service';
import { LogoutService } from '../../components/Authentication/auth/logout.service';
import { UserService } from '../../services/user';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @Input() isActive!: boolean;
  @ViewChild('navbarNav') navbarNav!: ElementRef;

  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);

  currentLanguage!: string | null;
  token!: string | null;
  tokenExists!: boolean;

  contentReady = true;
  showPopup = false;
  cartPopUp = false;
  showCart = true;

  cartItems: any[] = [];
  cartItemCount = 0;

  lang = [
    { code: 'en', name: 'English' },
    { code: 'ar', name: 'arabic' },
  ];

  constructor(

    private languageService: LanguageServiceService,
    private loginService: LoginService,
    private logoutService: LogoutService,
    private transloco: TranslocoService,
    private location: Location,
    private router: Router
  ) {
    let savedLang = 'en';

    if (this.isBrowser) {
      savedLang = localStorage.getItem('language') || 'en';
    }

    this.currentLanguage = savedLang;
    this.transloco.setActiveLang(savedLang);

  }

  // =========================
  // 🔁 Lifecycle
  // =========================
  ngOnInit(): void {
    if (!this.isBrowser) return;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.cartPopUp = false;
        this.token = localStorage.getItem('token');

        const path = this.location.path();
        this.showCart = !(path.includes('/Addorder') || path.includes('/Home'));

        this.loadCart();
      }
    });

    this.languageService.currentLanguage$.subscribe((lang) => {
      this.currentLanguage = lang;
      this.transloco.setActiveLang(lang);
    });

    this.checkForToken();
    this.loadCart();
  }

  ngAfterViewInit(): void {
    if (!this.isBrowser || !this.navbarNav) return;

    const navLinks =
      this.navbarNav.nativeElement.querySelectorAll('.nav-item');
    const navbarCollapse = document.querySelector('.navbar-collapse');

    navLinks.forEach((link: HTMLElement) => {
      link.addEventListener('click', () => {
        if (navbarCollapse?.classList.contains('show')) {
          const toggler = document.querySelector(
            '.navbar-toggler'
          ) as HTMLElement;
          toggler?.click();
        }
      });
    });
  }

  // =========================
  // 🌍 Language
  // =========================
  toggleLanguage() {
    const newLang = this.currentLanguage === 'en' ? 'ar' : 'en';

    this.currentLanguage = newLang;

    // ✅ Transloco Switch
    this.transloco.setActiveLang(newLang);

    // ✅ Save in localStorage
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('language', newLang);
    }

    // ✅ Notify service
    this.languageService.changeLanguage(newLang);
  }


  // =========================
  // 🔐 Auth
  // =========================
  checkForToken() {
    this.loginService.token$.subscribe((token) => {
      this.tokenExists = !!token;
      this.token = token;
    });
  }

  logout() {
    if (!this.isBrowser || !this.token) return;

    this.contentReady = true;
    this.logoutService.logout(this.token).subscribe({
      next: () => {
        localStorage.removeItem('cart');
        localStorage.removeItem('token');
        window.location.reload();
      },
      error: () => (this.contentReady = false),
    });
  }

  // =========================
  // 🛒 Cart
  // =========================
  loadCart() {
    if (!this.isBrowser) return;

    const storedCart = localStorage.getItem('cart');
    if (storedCart) {
      this.cartItems = JSON.parse(storedCart);
      this.cartItemCount = this.cartItems.length;
    } else {
      this.cartItems = [];
      this.cartItemCount = 0;
    }
  }

  cartPopUpOpen() {
    this.cartPopUp = true;
  }

  close() {
    this.cartPopUp = false;
  }

  removeFromCart(item: any) {
    if (!this.isBrowser) return;

    const index = this.cartItems.findIndex(
      (i) => i.id === item.id
    );

    if (index !== -1) {
      this.cartItems.splice(index, 1);
      localStorage.setItem('cart', JSON.stringify(this.cartItems));
      this.cartItemCount = this.cartItems.length;
    }

    if (this.cartItems.length === 0) {
      this.cartPopUp = false;
    }
  }

  quickOrder() {
    this.router.navigate(['/Addorder'], {
      queryParams: { cart: JSON.stringify(this.cartItems) },
    });
  }

  // =========================
  // ℹ️ UI Helpers
  // =========================
  openPopup() {
    this.showPopup = true;
  }

  closePopup() {
    this.showPopup = false;
  }

  help() {
    this.openPopup();
  }
}
